import { tv } from "tailwind-variants";

export const sidebar = tv({
  slots: {
    base: "bg-transparent md:min-h-screen h-full border-r border-gray-700 w-full relative transition-all duration-200",
    header:
      "flex border-b border-gray-700 items-center justify-center max-h-[73px] h-[73px]",
    logo: "w-full h-full overflow-hidden flex justify-center",
    logoImg: "object-left w-full object-cover",
    item: "flex !mx-auto overflow-hidden justify-start items-center gap-4 hover:bg-gray-700 cursor-pointer p-4 rounded-xl w-full h-12 min-h-12 max-h-12",
    submenu: "flex flex-col p-0 gap-4 pl-4 pt-4",
    link: "flex whitespace-nowrap cursor-pointer !mx-auto overflow-hidden justify-start items-center gap-4 hover:!text-white-500 cursor-pointer p-2 rounded-[8px] w-full min-h-8 max-h-8 text-xs",
    list: "flex flex-col mt-4 px-4 items-center gap-2",
  },
  variants: {
    open: {
      true: {
        base: "w-56 min-w-[280px]",
        logo: "max-w-56 w-56",
        item: "max-w-full",
        submenu: "default",
        logoImg: "max-w-full h-full  p-8",
        link: "pl-8 !text-white-500",
        list: "",
      },
      false: {
        base: "absolute max-h-[73px] md:relative md:max-h-full w-20 min-w-20",
        logoImg: "sr-onlyobject-scale-down !max-w-[160px] !h-10",
        logo: "max-w-11 w-11",
        item: "max-w-12",
        submenu:
          "absolute left-[70px] p-4 pb-0 border-gray-700 border top-0 bg-paper-400 z-50 min-w-[180px] rounded-lg max-w-[180px]",
        link: "pl-0",
        list: "hidden md:flex",
      },
    },
    active: {
      true: {
        item: "!bg-primary-600 !text-primary-500 hover:bg-primary-500",
        link: "bg-gray-600 text-white-500",
      },
      false: {
        item: "text-white-500",
        link: "text-gray-500",
      },
    },
    showSubItems: {
      true: {
        submenu: "flex",
      },
      false: {
        submenu: "hidden",
      },
    },
  },
  defaultVariants: {
    open: false,
    active: false,
    showSubItems: false,
  },
});
